import React from 'react';

import LandingMapSection from 'components/landing-map-section';
import {
  ASPIRANT_CTA,
  ASPIRANT_DESCRIPTION,
  ASPIRANT_NAV_BAR_BUTTON_TEXT,
  ASPIRANT_TAGLINE,
} from './constants';

type AspirantTopSectionProps = {
  mainButtonText?: string;
  navBarButtonText?: string;
  onNavBarButtonClick?: () => void;
  navBarButtonHrefId?: string;
  mainButtonHrefId?: string;
};

const AspirantTopSection = ({
  mainButtonText = ASPIRANT_CTA,
  navBarButtonText = ASPIRANT_NAV_BAR_BUTTON_TEXT,
  onNavBarButtonClick,
  navBarButtonHrefId,
  mainButtonHrefId,
}: AspirantTopSectionProps) => {
  return (
    <LandingMapSection
      description={ASPIRANT_DESCRIPTION}
      tagline={ASPIRANT_TAGLINE}
      navBarButtonText={navBarButtonText}
      mainButtonText={mainButtonText}
      onNavBarButtonClick={onNavBarButtonClick}
      navBarButtonHrefId={navBarButtonHrefId}
      mainButtonHrefId={mainButtonHrefId}
    />
  );
};

export default AspirantTopSection;
